import * as net from "../vipa/net";

export class Case {
    constructor() {
        $("#admin-invites").on("click", ".invites-removeItem", this.click);
    }

    click = (event: JQuery.ClickEvent) => {
        let ok = confirm("Really want to remove this invite?");
        if (!ok) {
            return
        }

        let token = this.getInviteToken(event);
        let data = {
            jsonrpc: "2.0",
            token: token
        }
        net.postJSON(
            "/j/admin-remove-invite/",
            data,
            (data: any) => {
                this.clickSuccess(data.result, token)
            },
        ).fail(this.clickFail);
    }

    clickSuccess(result: JQuery.PlainObject, token: number): void {
        let table = $("#invite-items").DataTable();
        let row = $(`#item-${token}`);
        row.hide("slow", () => { table.row(row).remove().draw(); });

        // Trace on analytics
        window.sa_event("remove_invite");
    }

    clickFail(response: JQuery.jqXHR): void {
        let modal = $("#modal-small");
        let content = $("#modal-small div");

        content.html(response.responseJSON.error);
        modal.foundation("open");
    }

    private getInviteToken(event: JQuery.ClickEvent): number {
        return $(event.currentTarget)
            .closest(".invite")
            .data("id");
    }
}
